




































import { Vue, Component, Prop } from 'vue-property-decorator';
import TransitionExpand from '@/components/transition-expand/TransitionExpand';
import { ExpandingListItem } from '@/types';
import { Getter } from 'vuex-class';

@Component({
  name: 'additional-info-block',
  components: {
    TransitionExpand,
  },
})
export default class extends Vue {

  @Prop({type: Object, required: true})
  private readonly item!: ExpandingListItem;

  @Getter('dataManagement/themeColor')
  private themeColor!: CSSStyleDeclaration['color'];

  private isExpanded: boolean = false;

  private get isSomeItemContentFilled(): boolean {
    return this.item.content && this.item.content.some((contentItem: string) => !!contentItem);
  }
}
